<div>
  <app-sidebar [visible]="visible" [mode]="mode"> </app-sidebar>

  <main
    [ngClass]="visible ? 'xl:w-[calc(100%-240px)] xl:ms-[240px]' : 'w-full'"
  >
    <app-header
      [isMenuOpen]="mode == 'overlay' && visible"
      (sidebarToggled)="toggleSidebar()"
    ></app-header>
    <div id="main-page" class="p-4">
      <router-outlet></router-outlet>
    </div>
  </main>
</div>
